import { render, staticRenderFns } from "./addExamPaper.vue?vue&type=template&id=36dc7180&scoped=true"
import script from "./AddPaper.js?vue&type=script&lang=js&external"
export * from "./AddPaper.js?vue&type=script&lang=js&external"
import style0 from "./addExamPaper.vue?vue&type=style&index=0&id=36dc7180&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dc7180",
  null
  
)

export default component.exports